module.exports = __webpack_public_path__ + "static/media/kbc.32202e4b.svg";